import axios from "axios";

const API_URL = "";

export const getLeads = (status) =>
  axios.get(`${API_URL}/api/leads${status ? `?status=${status}` : ""}`);

export const getLeadsStats = () =>
  axios.get(`${API_URL}/api/leads/stats`);

export const createLeadFromConversation = (conversationId, data = {}) =>
  axios.post(`${API_URL}/api/leads/from-conversation/${conversationId}`, data);

export const updateLead = (leadId, data) =>
  axios.patch(`${API_URL}/api/leads/${leadId}`, data);

export const deleteLead = (leadId) =>
  axios.delete(`${API_URL}/api/leads/${leadId}`);

export const getLeadsRevenue = (period = "all") =>
  axios.get(`${API_URL}/api/leads/revenue?period=${period}`);